import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import {Button, Modal, Table} from "antd";
import { priceTableDataIndex } from "../../staticObjects";
import {
    getAdminClientList, getSingleClientList, getSingleClientListing, updateBrokerClient, updateClient, updateAdminUser
} from "../../../redux/services";
import style from "../../Pages/Dashboard/style.module.scss";
import SearchBar from "../../Common/SearchBar/SearchBar";
import {EyeOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router";
import ClientForm from "../../Pages/Dashboard/clientForm";


function AdminAgent() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { agentClient, total } = useSelector((state) => state.client);
    const { data } = useSelector((state) => state?.user);
    const [forRole, setForRole] = useState('broker');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10); // Default page size
    const totalItems = Number(total) || 0;
    const [client, setClient] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [iseditModalVisible, setIseditModalVisible] = useState(false);
    const { singlePost } = useSelector((state) => state.client);

    useEffect(() => {
        const currentUrl = window.location.href;
        if (data.role === "admin") {
            let role = 'broker';
            if (data.role === "admin") {
                if (currentUrl.includes('broker')) {
                    role = 'broker';
                } else if (currentUrl.includes('agents')) {
                    role = 'agent';
                } else if (currentUrl.includes('contact')) {
                    role = 'client';
                }
            }
            setForRole(role);
            dispatch(getAdminClientList({
                role: role,
                page: currentPage,
                limit: pageSize
            })).then(response => {
            });
        }
    }, [window.location.href]);

    const getRoleFromURL = () => {
        const currentUrl = window.location.href;
        if (currentUrl.includes('broker')) return 'broker';
        if (currentUrl.includes('agents')) return 'agent';
        if (currentUrl.includes('contact')) return 'client';
        return 'broker';
    };

    const { phone_number, email, total_agreements, active_agreements, role, name, expiry_date } = priceTableDataIndex;
    const priceTbCol = [
        { dataIndex: 'name', title: "Name" },
        { dataIndex: 'phone_number', title: "Phone Number" },
        { dataIndex: 'email', title: "Email" },
        { dataIndex: 'role', title: "Status" },
        // { dataIndex: 'total_agreements', title: "Total Agreements" },
        // { dataIndex: 'active_agreements', title: "Active Agreements" },
    ];

    if (window.location.href.includes('contact')) {
        priceTbCol.push({ dataIndex: 'expiry_date', title: "Expiration Date" });
    }
    priceTbCol.push({ dataIndex: 'action', title: "Action" });

    const handleSearch = (searchTerm) => {
        const currentUrl = window.location.href;

        if (data.role === "admin") {
            let role = 'broker';
            if (data.role === "admin") {
                if (currentUrl.includes('broker')) {
                    role = 'broker';
                } else if (currentUrl.includes('agents')) {
                    role = 'agent';
                } else if (currentUrl.includes('contact')) {
                    role = 'client';
                }
            }
            setForRole(role);
            dispatch(getAdminClientList({
                role: role,
                page: 1,
                limit: 10,
                search: searchTerm
            }));
        } else {
            dispatch(getAdminClientList({
                role: forRole,
                search: searchTerm
            }))
        }
    };

    const handleTableChange = (pagination) => {
        const page = Number(pagination.current) || 1;
        const limit = Number(pagination.pageSize) || 10;

        setCurrentPage(page);
        setPageSize(limit);
        dispatch(getAdminClientList({ page, limit, role: forRole }));
    };

    const handleEditClick = (clientdata) => {
        if (!clientdata) return;
        setClient(clientdata);
        setIseditModalVisible(true);
    };

    const handleToggleUserState = (user) => {
        const newState = user.state === 'active' ? 'inactive' : 'active';

        dispatch(updateAdminUser({
            id: user.id,
            state: newState,
            role: user.role
        }));
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setIseditModalVisible(false);
        setClient(null);
        setIsDeleteModalVisible(false);
        setItemToDelete(null);
    };

    const handleEditForm = (formValues) => {
        dispatch(updateAdminUser({
            ...formValues,
            id: client.id,
            role: client.role,
        }));
        setIseditModalVisible(false);
    };

    const handleTotalAgents = (agentdata) => {
        navigate(`/inkadmin/agents/${agentdata.id}`)
    };

    const handleTotalContacts = (agentdata) => {
        navigate(`/inkadmin/contacts/${agentdata.id}`)
    };

    const dataList = (clientdata) => {
        if (clientdata && Array.isArray(clientdata) && clientdata.length > 0) {
            return clientdata?.map((item) => ({
                ...item,
                name: (
                    <>
                    {item.name == null ? 'Unprovided' : item.name}
                    </>
                ),
                phone_number: (
                    <a
                        href={`sms:${item.phone_number}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {item.phone_number == null ? 'Unprovided' : item.phone_number}
                    </a>
                ),
                email: (
                    <a
                        href={`mailto:${item.email}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {item.email}
                    </a>
                ),
                role: (
                    <Button
                        style={{
                            backgroundColor: item.role === 'contact' ? '#B9A143' : '#4CAF50',
                            color: "white",
                            padding: "7px 20px",
                            border: "none",
                            borderRadius: "28px",
                            cursor: "pointer",
                            margin: "5px",
                            width: "110px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center"
                        }}
                    >
                        {item.role}
                    </Button>
                ),
                action: (

                    <div className={`${style.buyData}`}>
                        {window.location.href.includes('broker') && (
                            <>
                                <Button
                                    style={{
                                        margin: "2px",
                                        padding: "5px 15px",
                                        backgroundColor: "white",
                                        borderRadius: "20px",
                                    }}
                                    icon={<EyeOutlined />}
                                    onClick={() => handleTotalAgents(item)}
                                >
                                    Total Agents
                                </Button>
                                <Button
                                    style={{
                                        margin: "2px",
                                        padding: "5px 15px",
                                        backgroundColor: "white",
                                        borderRadius: "20px",
                                    }}
                                    icon={<EyeOutlined />}
                                    onClick={() => handleTotalContacts(item)}
                                >
                                    Total Contacts
                                </Button>
                            </>
                        )}
                        {window.location.href.includes('agents') && (
                            <Button
                                style={{
                                    margin: "2px",
                                    padding: "5px 15px",
                                    backgroundColor: "white",
                                    borderRadius: "20px",
                                }}
                                icon={<EyeOutlined />}
                                onClick={() => handleTotalContacts(item)}
                            >
                                Total Contacts
                            </Button>
                        )}
                        <Button
                            style={{
                                margin: "2px",
                                padding: "5px 15px",
                                backgroundColor: "white",
                                borderRadius: "20px",
                            }} onClick={() => handleEditClick(item)}
                        >
                            Edit
                        </Button>
                        <Button
                            style={{
                                margin: "2px",
                                padding: "5px 15px",
                                backgroundColor: item.state === 'active' ? '#ff4d4f' : '#4CAF50',
                                color: 'white',
                                borderRadius: "20px",
                            }}
                            onClick={() => handleToggleUserState(item)}
                        >
                            {item.state === 'active' ? 'Disable' : 'Enable'}
                        </Button>

                    </div>
                )
            }));
        } else {
            return [];
        }
    };

    return (
        <>
            <div className="assetTable AdminOuter" style={{ marginTop: '30px' }}>
                <div className={`${style.home}`}>
                    <div className={`${style.home__inner}`} style={{ maxWidth: '100% !important' }}>
                        {data.role === "admin" ? (
                            <div className="pageMain">
                                <div className={style.pricesData}>
                                    <div className={`${style.home__prices}`}>
                                        <div className="page_title d-flex">
                                            <h4>All {`${forRole.charAt(0).toUpperCase() + forRole.slice(1)}s`}</h4>
                                                <div style={{ alignItems: 'end', gap: '10px', marginBottom: '10px' }}>
                                                    <SearchBar
                                                        onSearch={handleSearch}
                                                        placeholder={`Search ${forRole.charAt(0).toUpperCase() + forRole.slice(1)} Name...`}
                                                    />
                                                </div>
                                        </div>
                                        <div className="tableMain">
                                            <Table
                                                rowKey={(obj) => obj.keyId}
                                                columns={priceTbCol}
                                                dataSource={dataList(agentClient)}
                                                pagination={{
                                                    current: Number(currentPage) || 1,
                                                    pageSize: Number(pageSize) || 10,
                                                    total: Number(totalItems) || 0,
                                                    showSizeChanger: true,
                                                    onShowSizeChange: handleTableChange
                                                }}
                                                onChange={handleTableChange}
                                                className="priceTable"
                                                style={{ boxShadow: "none" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            " "
                        )}
                    </div>
                </div>
                <Modal
                    title={
                        client
                            ? `Edit ${client.role?.charAt(0).toUpperCase() + client.role?.slice(1)}`
                            : "Add New Contact"
                    }
                    visible={iseditModalVisible}
                    onCancel={handleCancel}
                    footer={null}
                    className="add-new-agent"
                >
                    <ClientForm
                        client={singlePost?.data || client}
                        extraData={true}
                        onSave={handleEditForm}
                        onCancel={handleCancel}
                    />
                </Modal>


            </div>
        </>
    );
}

export default AdminAgent;
